import { Auth } from '@/api'
import axios from 'axios'

export default {
    data: function () {
        return {
          keyword_member:'',
          keyword_member_new:'',
        }
      },
      methods: {
        searchMember(search) {
          if (search) {
            this.keyword_member = search
            this.getMember()
         }
        },
        searchMemberNew(search) {
          if (search) {
            this.keyword_member_new = search
            this.getMemberNew()
         }
        },
        searchMemberWithoutBranch(search) {
          if (search) {
            this.keyword_member = search
            this.getMemberWithoutBranch()
         }
        },
        async getMember() {
          let branch = ''
            if (this.addData.branch_id != null && this.addData.branch_id != 'null' && this.addData.branch_id != '' && this.addData.branch_id) {
            branch = this.addData.branch_id

           }

            await axios.get('fitness/v1/member/data_entry?branch_id=' + branch + '&limit=50' + '&keyword=' + this.keyword_member).then(async response => {
              this.dataMember = response.data.data.rows
            this.optionsMember = [
              { value: null, text: 'Please select' }
            ]
            for (var i = 0; i < this.dataMember.length; i++) {
              let memberBranchId
              if(!this.dataMember[i].branch_id) {
                memberBranchId = '(FT-' + this.dataMember[i].id + ') ' + this.dataMember[i].first_name + ' ' + this.dataMember[i].last_name
              } else {
                memberBranchId = '(' + this.dataMember[i].branch.codename + '-' + this.dataMember[i].id + ') ' + this.dataMember[i].first_name + ' ' + this.dataMember[i].last_name
              }
              var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: this.dataMember[i].id, text: memberBranchId})
              this.optionsMember.push(dataComplete)
            }
         }).catch(error => {
           console.log('error', error)
         })
        },
        async getMemberNew() {
          let branch = ''
            if (this.addData.branch_id != null && this.addData.branch_id != 'null' && this.addData.branch_id != '' && this.addData.branch_id) {
            branch = this.addData.branch_id

           }

            await axios.get('fitness/v1/member/data_entry?' + 'limit=50' + '&keyword=' + this.keyword_member_new).then(async response => {
              this.dataMember = response.data.data.rows
            this.optionsMemberNew = [
              { value: null, text: 'Please select' }
            ]
            for (var i = 0; i < this.dataMember.length; i++) {
              let memberBranchId
              if(!this.dataMember[i].branch_id) {
                memberBranchId = '(FT-' + this.dataMember[i].id + ') ' + this.dataMember[i].first_name + ' ' + this.dataMember[i].last_name
              } else {
                memberBranchId = '(' + this.dataMember[i].branch.codename + '-' + this.dataMember[i].id + ') ' + this.dataMember[i].first_name + ' ' + this.dataMember[i].last_name
              }
              var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: this.dataMember[i].id, text: memberBranchId})
              this.optionsMemberNew.push(dataComplete)
            }
         }).catch(error => {
           console.log('error', error)
         })
        },
        async getMemberWithoutBranch() {
          let branch = ''
          //   if (this.addData.branch_id != null && this.addData.branch_id != 'null' && this.addData.branch_id != '' && this.addData.branch_id) {
          //   branch = this.addData.branch_id

          //  }

            await axios.get('fitness/v1/member/data_entry?branch_id=' + branch + '&limit=50' + '&keyword=' + this.keyword_member).then(async response => {
              this.dataMember = response.data.data.rows
            this.optionsMember = [
              { value: null, text: 'Please select' }
            ]
            for (var i = 0; i < this.dataMember.length; i++) {
              let memberBranchId
              if(!this.dataMember[i].branch_id) {
                memberBranchId = '(FT-' + this.dataMember[i].id + ') ' + this.dataMember[i].first_name + ' ' + this.dataMember[i].last_name
              } else {
                memberBranchId = '(' + this.dataMember[i].branch.codename + '-' + this.dataMember[i].id + ') ' + this.dataMember[i].first_name + ' ' + this.dataMember[i].last_name
              }
              var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: this.dataMember[i].id, text: memberBranchId})
              this.optionsMember.push(dataComplete)
            }
         }).catch(error => {
           console.log('error', error)
         })
        },
      },

}
